module.exports = require("@mui/icons-material/Clear");